function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,60.392159%,20.392157%)",
      fillOpacity: 1
    },
    d: "M 0.132812 16.800781 C 0.132812 16.261719 0.132812 15.726562 0.179688 15.125 C 2.644531 13.433594 5.066406 11.804688 7.542969 10.132812 C 5.96875 9.070312 4.5 8.070312 3.023438 7.085938 C 2.066406 6.449219 1.097656 5.828125 0.132812 5.199219 C 0.132812 4.664062 0.132812 4.125 0.195312 3.527344 C 0.679688 3.464844 1.105469 3.5 1.523438 3.460938 C 2.265625 3.386719 2.871094 3.621094 3.484375 4.050781 C 5.609375 5.535156 7.765625 6.984375 9.929688 8.40625 C 10.273438 8.632812 10.738281 8.769531 11.148438 8.773438 C 14.140625 8.808594 17.136719 8.796875 20.132812 8.800781 C 20.132812 9.648438 20.132812 10.496094 20.070312 11.410156 C 17.011719 11.476562 14.015625 11.464844 11.023438 11.492188 C 10.675781 11.492188 10.28125 11.621094 9.988281 11.8125 C 8.191406 12.996094 6.359375 14.132812 4.660156 15.441406 C 3.285156 16.5 1.851562 17.046875 0.132812 16.800781 Z M 0.132812 16.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 20.132812 8.742188 C 17.136719 8.796875 14.140625 8.808594 11.148438 8.773438 C 10.738281 8.769531 10.273438 8.632812 9.929688 8.40625 C 7.765625 6.984375 5.609375 5.535156 3.484375 4.050781 C 2.871094 3.621094 2.265625 3.386719 1.523438 3.460938 C 1.105469 3.5 0.679688 3.464844 0.195312 3.464844 C 0.132812 2.359375 0.132812 1.25 0.132812 0.140625 C 6.800781 0.140625 13.464844 0.140625 20.132812 0.140625 C 20.132812 1.214844 20.132812 2.277344 20.070312 3.40625 C 14.800781 3.46875 9.59375 3.46875 4.222656 3.46875 C 6.433594 4.96875 8.496094 6.375 10.566406 7.769531 C 10.6875 7.851562 10.859375 7.886719 11.003906 7.886719 C 14.046875 7.886719 17.089844 7.875 20.132812 7.867188 C 20.132812 8.140625 20.132812 8.410156 20.132812 8.742188 Z M 20.132812 8.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.132812 16.863281 C 1.851562 17.046875 3.285156 16.5 4.660156 15.441406 C 6.359375 14.132812 8.191406 12.996094 9.988281 11.8125 C 10.28125 11.621094 10.675781 11.492188 11.023438 11.492188 C 14.015625 11.464844 17.011719 11.476562 20.070312 11.472656 C 20.132812 11.738281 20.132812 12.011719 20.070312 12.332031 C 17.082031 12.378906 14.152344 12.367188 11.222656 12.386719 C 10.914062 12.390625 10.566406 12.503906 10.308594 12.671875 C 8.585938 13.804688 6.882812 14.960938 5.171875 16.113281 C 4.890625 16.304688 4.617188 16.503906 4.199219 16.800781 C 9.628906 16.800781 14.882812 16.800781 20.132812 16.800781 C 20.132812 17.910156 20.132812 19.015625 20.132812 20.125 C 13.464844 20.125 6.800781 20.125 0.132812 20.125 C 0.132812 19.054688 0.132812 17.988281 0.132812 16.863281 Z M 0.132812 16.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,80.000001%)",
      fillOpacity: 1
    },
    d: "M 20.132812 16.738281 C 14.882812 16.800781 9.628906 16.800781 4.199219 16.800781 C 4.617188 16.503906 4.890625 16.304688 5.171875 16.113281 C 6.882812 14.960938 8.585938 13.804688 10.308594 12.671875 C 10.566406 12.503906 10.914062 12.390625 11.222656 12.386719 C 14.152344 12.367188 17.082031 12.378906 20.070312 12.390625 C 20.132812 13.824219 20.132812 15.25 20.132812 16.738281 Z M 20.132812 16.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 20.132812 7.804688 C 17.089844 7.875 14.046875 7.886719 11.003906 7.886719 C 10.859375 7.886719 10.6875 7.851562 10.566406 7.769531 C 8.496094 6.375 6.433594 4.96875 4.222656 3.46875 C 9.59375 3.46875 14.800781 3.46875 20.070312 3.46875 C 20.132812 4.890625 20.132812 6.316406 20.132812 7.804688 Z M 20.132812 7.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,0.784314%,0%)",
      fillOpacity: 1
    },
    d: "M 0.132812 14 C 0.132812 11.507812 0.132812 9.015625 0.15625 6.40625 C 0.460938 6.457031 0.75 6.613281 1.023438 6.796875 C 2.65625 7.886719 4.285156 8.984375 5.992188 10.128906 C 5.375 10.546875 4.839844 10.921875 4.289062 11.28125 C 2.90625 12.191406 1.519531 13.09375 0.132812 14 Z M 0.132812 14 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,78.431374%,0.784314%)",
      fillOpacity: 1
    },
    d: "M 0.132812 14.058594 C 1.519531 13.09375 2.90625 12.191406 4.289062 11.28125 C 4.839844 10.921875 5.375 10.546875 5.992188 10.128906 C 4.285156 8.984375 2.65625 7.886719 1.023438 6.796875 C 0.75 6.613281 0.460938 6.457031 0.15625 6.34375 C 0.132812 6.039062 0.132812 5.679688 0.132812 5.261719 C 1.097656 5.828125 2.066406 6.449219 3.023438 7.085938 C 4.5 8.070312 5.96875 9.070312 7.542969 10.132812 C 5.066406 11.804688 2.644531 13.433594 0.179688 15.0625 C 0.132812 14.75 0.132812 14.433594 0.132812 14.058594 Z M 0.132812 14.058594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZar);
export default __webpack_public_path__ + "static/media/zar.a3c4c805375c4f09d5220e0762ac64c8.svg";
export { ForwardRef as ReactComponent };